module.exports = __webpack_public_path__ + "static/media/fl_cast_award.01360be1.jpg";